export var ERROR_CODE_CHECKOUT_GENERIC='EUNKNOWN';